import {Inject, Injectable} from '@angular/core';
import {App, LoadingController, ToastController} from 'ionic-angular';
import {EnvVariables} from '../../environment-variables/environment-variables.token';
import {AbstractAdvTechService} from '../../shared/services/advtech/abstract-advtech.service';
import {ImageService} from '../../shared/services/advtech/image/image.service';
import {ListEntity} from '../entities/list.entity';
import {WelcomeList} from '../interfaces/welcome-list/welcome-list.interface';
import {Observable} from 'rxjs/Observable';
import {WindowService} from '../../shared/services/window/window.service';
import {PrismConfigOptions} from '../../environment-variables/environment-variables.interface';
import {HttpClient} from "@angular/common/http";

/**
 * Abstract class used to call the hub and get listing information
 * @abstract
 * @class
 * @extends AbstractAdvTechService
 * @implements {WelcomeList}
 */
@Injectable()
export abstract class AbstractListService extends AbstractAdvTechService implements WelcomeList {

  /** inheritdoc */
  protected prefix = 'mobile/content/query';

  /**
   * Enabled types
   * @type {string[]}
   * @protected
   */
  protected enabledTypes: string[];

  /**
   * List type used in the loading message
   * @type {string}
   * @protected
   */
  protected listType: string;

  /**
   * Page size
   * @type {number}
   * @protected
   */
  protected limit: number = 20;

  /**
   * offset or page. Function of the limit. E.g. Page 2 is limit * 2
   * @type {number}
   * @protected
   */
  protected offset: number = 0;

  /**
   * What to sort by
   * @type {string}
   * @protected
   */
  protected sortBy: string = 'date_updated';

  /**
   * Status of the content
   * @type {string}
   * @protected
   */
  protected status: string = '*';

  /**
   * Tells the hub whether or not to showMineOnly
   * @type {boolean}
   * @protected
   */
  protected showMineOnly: boolean = true;

  /**
   * Sets the keyword for searching
   * @type {string}
   * @protected
   */
  protected keyword: string = '';

  /** @inheritdoc */
  constructor(@Inject(EnvVariables) public envVariables: PrismConfigOptions,
    protected app: App,
    protected http: HttpClient,
    protected loadingCtrl: LoadingController,
    protected toastCtrl: ToastController,
    public window: WindowService,
    protected imgService: ImageService) {
    super(envVariables, app, http, loadingCtrl, toastCtrl, window);
  }

  /** @inheritdoc */
  getList(skipLoading: boolean = false): Observable<any> {
    const formData = this.getFormData();

    this.setParams(formData);
    this.setLoadingMessage(`Getting ${this.listType}`);

    return this.callPostEndpoint('mobile_listing_query_form_provider/paged_list/mobile.item_structure/', skipLoading);
  }

  /** @inheritdoc */
  setOffset(offset: number): this {
    this.offset = offset;

    return this;
  }

  /** @inheritdoc */
  getOffset() {
    return this.offset;
  }

  /** @inheritdoc */
  getLimit() {
    return this.limit;
  }

  /**
   * Gets the term for search
   * @returns {string}
   */
  getKeyword(): string {
    return this.keyword;
  }

  /**
   * Sets the keyword
   * @param {string} keyword term for the search
   * @returns {this}
   */
  setKeyword(keyword): this {
    this.keyword = keyword;
    return this;
  }

  /** @inheritdoc */
  abstract populateListEntities(objArr: any[]): ListEntity[];

  /** @inheritdoc */
  getFormData() {
    const ret = {
      'advanced_search[contentTypes][]': this.enabledTypes,
      'advanced_search[keyword]': this.keyword,
      'advanced_search[limit]': this.limit,
      'advanced_search[offset]': this.offset,
      'advanced_search[sortBy]': this.sortBy,
      'advanced_search[status]': this.status,
      'skipFormView': true,
    };

    if (this.showMineOnly) {
      ret['advanced_search[modified][modifiedShowMineOnly]'] = true;
    }

    return ret;
  }
}


// WEBPACK FOOTER //
// ./src/app/list/services/abstract-list.service.ts